import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { CSVLink } from 'react-csv';
import { exportAccountsPdf } from '../utils/pdfExporter';

function Accounts() {
  const [logs, setLogs] = useState([]);
  const [totals, setTotals] = useState({ debit: 0, credit: 0 });
  const [filters, setFilters] = useState({ start: '', end: '', type: '' });

  const fetchData = () => {
    const params = {};
    if (filters.start) params.start = filters.start;
    if (filters.end) params.end = filters.end;
    if (filters.type) params.type = filters.type;

    axios.get('/accounts', { params })
      .then(res => {
        setLogs(res.data);
        const debit = res.data.reduce((sum, l) => sum + (parseFloat(l.debit) || 0), 0);
        const credit = res.data.reduce((sum, l) => sum + (parseFloat(l.credit) || 0), 0);
        setTotals({ debit, credit });
      });
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const groupedLogs = logs.reduce((acc, log) => {
    if (!acc[log.type]) acc[log.type] = [];
    acc[log.type].push(log);
    return acc;
  }, {});

  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Accounts (Grouped Ledger + Filters)</h2>

        <div className="grid grid-cols-5 gap-4 mb-4">
          <input className="border p-2" type="date" value={filters.start} onChange={e => setFilters({ ...filters, start: e.target.value })} />
          <input className="border p-2" type="date" value={filters.end} onChange={e => setFilters({ ...filters, end: e.target.value })} />
          <select className="border p-2" value={filters.type} onChange={e => setFilters({ ...filters, type: e.target.value })}>
            <option value="">All Types</option>
            <option value="sale">Sale</option>
            <option value="purchase">Purchase</option>
            <option value="expense">Expense</option>
          </select>
          <CSVLink data={logs} filename="accounts_export.csv" className="bg-green-600 text-white p-2 rounded text-center">Export CSV</CSVLink>
          <button onClick={() => exportAccountsPdf(logs)} className="bg-red-600 text-white p-2 rounded">Export PDF</button>
        </div>

        <div className="bg-gray-100 p-4 rounded shadow mb-4">
          <p className="font-semibold">Total Debit: <span className="text-red-600">${totals.debit.toFixed(2)}</span></p>
          <p className="font-semibold">Total Credit: <span className="text-green-600">${totals.credit.toFixed(2)}</span></p>
          <p className="font-semibold">Balance: <span className="text-blue-600">${(totals.credit - totals.debit).toFixed(2)}</span></p>
        </div>

        {Object.entries(groupedLogs).map(([type, group]) => (
          <div key={type} className="mb-6">
            <h3 className="text-lg font-bold capitalize mb-2">{type} Entries</h3>
            <table className="table-auto w-full text-left border mb-2">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-2 border">Reference</th>
                  <th className="p-2 border">Debit</th>
                  <th className="p-2 border">Credit</th>
                  <th className="p-2 border">Description</th>
                  <th className="p-2 border">Date</th>
                </tr>
              </thead>
              <tbody>
                {group.map(log => (
                  <tr key={log.id}>
                    <td className="p-2 border">{log.reference}</td>
                    <td className="p-2 border text-red-600">{log.debit}</td>
                    <td className="p-2 border text-green-600">{log.credit}</td>
                    <td className="p-2 border">{log.description}</td>
                    <td className="p-2 border">{new Date(log.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Accounts;